module.exports = __webpack_public_path__ + "img/shipo-icon-docking-barge.b63d4186.svg";